/**
 * SVG Default icon
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const propTypes = {
  classes: PropTypes.shape({
    styleOne: PropTypes.string.isRequired,
    styleTwo: PropTypes.string.isRequired,
  }).isRequired,
};

export function UnstyledDefaultIcon({ ...props }) {
  const { classes, ...additionalProps } = props;
  const { styleOne } = classes;
  return (
    <SvgIcon viewBox="0 0 25 28.1" {...additionalProps}>
      <g>
        <polygon
          id="Polygon"
          className={styleOne}
          points="12.5,0.6 24.5,7.3 24.5,20.8 12.5,27.6 0.5,20.8 0.5,7.3"
        />
      </g>
    </SvgIcon>
  );
}

UnstyledDefaultIcon.propTypes = propTypes;

const styles = () => ({
  styleOne: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: '#F2F2F0',
    stroke: '#3C9BA0',
  },
  styleTwo: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: '#3C9BA0',
  },
});

export default withStyles(styles)(UnstyledDefaultIcon);
